import { z } from 'zod';
import { TDetailedErrorResponse } from 'src_server/trpc/types/error/detailedError';

export const InputSchema = z.object({
    days: z.number()
});

export type ChangePlayBrakeInput = z.infer<typeof InputSchema>;

export type TPlayBrakeResponseType =
    { responseStatus: 'success'} |
    { responseStatus: 'error'; data: TDetailedErrorResponse }



